(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@alifd/next")["Menu"], require("@alifd/next")["Icon"], require("@alifd/next")["ConfigProvider"]);
	else if(typeof define === 'function' && define.amd)
		define([["@alifd/next","Menu"], ["@alifd/next","Icon"], ["@alifd/next","ConfigProvider"]], factory);
	else if(typeof exports === 'object')
		exports["___ReactSimulatorRenderer___"] = factory(require("@alifd/next")["Menu"], require("@alifd/next")["Icon"], require("@alifd/next")["ConfigProvider"]);
	else
		root["___ReactSimulatorRenderer___"] = factory(root["Next"]["Menu"], root["Next"]["Icon"], root["Next"]["ConfigProvider"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__22__, __WEBPACK_EXTERNAL_MODULE__69__) {
return 